import { defineMessages } from "react-intl";
import { stdnum } from "stdnum";

const ES_TAX_IDS = {
  NIF_NIE: "NIF_NIE",
  NIF_NIE_CIF: "NIF_NIE_CIF",
};

const ES_TAX_IDS_META = {
  [ES_TAX_IDS.NIF_NIE]: {
    type: ES_TAX_IDS.NIF_NIE,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_short_name",
        defaultMessage: "NIF/NIE",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_name",
        defaultMessage:
          "Fiscal Identification Number / Foreigner Identification Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_full_name",
        defaultMessage:
          "Fiscal Identification Number / Foreigner Identification Number (NIF/NIE)",
      },
    }),
    validationFn: (value) => {
      const nif = stdnum.ES.nif.validate(value);
      const nie = stdnum.ES.nie.validate(value);
      return nif.isValid ? nif : nie;
    },
    format: "X0000000X",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_format",
        defaultMessage: "9 alphanumeric characters",
      },
    }),
  },
  [ES_TAX_IDS.NIF_NIE_CIF]: {
    type: ES_TAX_IDS.NIF_NIE_CIF,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_cif_short_name",
        defaultMessage: "NIF/NIE/CIF",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_cif_name",
        defaultMessage: "Spanish Tax ID",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_cif_full_name",
        defaultMessage: "Spanish Tax ID (NIF/NIE/CIF)",
      },
    }),
    validationFn: (value) => {
      const nif = stdnum.ES.nif.validate(value);
      const nie = stdnum.ES.nie.validate(value);
      const cif = stdnum.ES.cif.validate(value);
      return nif.isValid ? nif : nie.isValid ? nie : cif;
    },
    format: "X0000000X",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.nif_nie_cif_format",
        defaultMessage: "9 alphanumeric characters",
      },
    }),
  },
};

export { ES_TAX_IDS, ES_TAX_IDS_META };
